import DomainEntity from '@/models/DomainEntity'

export default class StateStaff extends DomainEntity {
  static get collectionName() {
    return 'statestaff/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      items: {},
    }
  }
}
